<template>
  <div>
    <load-profile />
    <!-- Table Container Card -->

    <jackpot @success="refreshWinnerList" />
    <b-card>
      <validation-observer
        ref="updateForm"
        #default="{ invalid }"
      >
        <!-- form -->
        <n-form-confirmation
          key="updateForm"
          :form="$refs.updateForm"
          :disabled="invalid"
          @submit="submit"
        >
          <n-input
            v-model="data"
            :fields="fields"
            :init-value="initData"
          />
          <b-row>
            <b-col
              cols="12"
              class="text-right"
            >
              <n-button-loading
                v-if="$can('update', 'bet-setting')"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mt-1"
                :loading="loading"
                :disabled="invalid"
              >
                {{ $t("button.saveChanges") }}
              </n-button-loading>
            </b-col>
          </b-row>
        </n-form-confirmation>
      </validation-observer>
    </b-card>

    <list ref="winnerList" />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
} from 'bootstrap-vue'
// eslint-disable-next-line import/no-cycle
import Repository from '@/repositories/RepositoryFactory'
import Ripple from 'vue-ripple-directive'
import NButtonLoading from '@/components/NButtonLoading.vue'
import NFormConfirmation from '@/components/NFormConfirmation.vue'
import NInput from '@/components/NInput.vue'
import Toast from '@/libs/toast'
import FormInput from './formInput'
import Jackpot from './Jackpot.vue'
import List from './List.vue'

const JackpotSettingRepository = Repository.get('jackpotSetting')

export default {
  components: {
    BRow,
    BCol,
    BCard,
    NButtonLoading,
    NFormConfirmation,
    NInput,
    Jackpot,
    List,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      data: {
        betDuration: 0,
        winPercent: 0,
        payouts: [],
      },
      initData: {},
      loading: false,
    }
  },
  mounted() {
    this.show()
  },
  methods: {
    refreshWinnerList() {
      this.$refs.winnerList.list()
    },
    show() {
      JackpotSettingRepository.show().then(response => {
        const { data } = response.data
        this.initData = {
          ...data,
        }
      })
    },
    submit() {
      this.$refs.updateForm.validate().then(success => {
        if (success) {
          this.loading = true
          JackpotSettingRepository.update(this.data)
            .then(() => {
              Toast.fire({
                icon: 'success',
                title: this.$t('alert.saveSuccess'),
              })
            })
            .catch(error => {
              if (error.response?.data?.message) {
                this.$refs.updateForm.setErrors(error.response?.data?.message)
              }
            })
            .then(() => {
              this.loading = false
            })
        }
      })
    },
  },
  setup() {
    const fields = FormInput.map(value => value)

    return { fields }
  },
}
</script>
